import React, { Component } from 'react'
import { message, Alert, Icon } from "antd"
import { inject, observer } from 'mobx-react'
import { FaEthereum, FaUserCircle, FaLifeRing } from 'react-icons/fa';
import { rollDice } from '../../contract/Dice';
import { ethMultiplier } from '../../constants';
import ContractStore from '../../stores/ContractStore';
import Web3Store from '../../stores/Web3Store'
@observer(["AdminStore", "web3Store"])
class CoinFlipper extends Component {

    //  USerCircle is heads (smile)  is side 1
    // LidfeRing is tails side 2 (check-circle)
    constructor(props) {
        super(props);

        this.state = {
            coinIconShowing: 1,
            coinIconToShow: <FaUserCircle className="" style={{ fontSize: "120pt" }} />,
            flipButton: <button style={{}} onClick={this.flipCoin.bind(this)} className="custom-btn-dice">FLIP</button>,
            checkChoiceBorder: "none",
            smileChoiceBorder: "none",
            coinChoice: 0,
            valueOneBorder: "none",
            valueTwoBorder: "solid #40a9ff",
            valueThreeBorder: "none",
            playersBetValue: 0.02 * ethMultiplier,
            coinClass: "",
            responseText: "",
            smartContractBetId: "",
            stillFlipping: false,
            loadingVisible: false
        }
        this.timeoutLoop = this.timeoutLoop.bind(this);
        this.flipCoin = this.flipCoin.bind(this);
        this.coinClicked = this.coinClicked.bind(this);
        this.betValueClicked = this.betValueClicked.bind(this);
    }

    componentDidMount() {
        let self = this;

        // Listen for our filtered results
        ContractStore.listen("Dice", "NewOraclizeQuery", {}, (err, event) => {
            if (!err) {
                console.log('event ' + JSON.stringify(event));
                if (event.returnValues.bettor.toUpperCase() == Web3Store.account.toUpperCase()) {
                    self.setState({ smartContractBetId: event.returnValues.betId });
                }
            } else { console.log("error " + err) }
        });

        ContractStore.listen("Dice", "Winner", {}, (err, event) => {
            if (!err) {
                console.log('event ' + JSON.stringify(event));
                if (event.returnValues.betId == self.state.smartContractBetId) {
                    self.setState({
                        flipResponse: Number(event.returnValues.randomNumber),
                        coinIconToShow: Number(event.returnValues.randomNumber) == 1 ? <FaUserCircle className="" style={{ fontSize: "120pt" }} /> : <FaLifeRing style={{ fontSize: "120pt" }} />,
                        stillFlipping: false,
                        loadingVisible: false,
                        coinClass: "pulse",
                        flipButton: <button style={{}} onClick={self.flipCoin.bind(self)} className="custom-btn-dice">FLIP</button>,
                    });
                    self.props.AdminStore.setCoinFlipping(false);
                    setTimeout(() => {
                        if (self.state.coinClass == "pulse") {
                            self.setState({ coinClass: "" });
                        }
                    }, 6010);
                    if (self.state.coinChoice == self.state.flipResponse) {
                        self.setState({
                            responseText: <div style={{ color: '#27f727' }}>YOU WIN    <span style={{ fontSize: "28pt", color: "#40a9ff" }}>
                                {(((self.state.playersBetValue * 2) - ((self.state.playersBetValue * 2) / 100)) / ethMultiplier).toFixed(5)}</span> <FaEthereum /> ETH</div>
                        });

                    } else {
                        self.setState({ responseText: <div style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</div> });
                    }
                }
            } else { console.log("error " + err) }
        });

        ContractStore.listen("Dice", "Loser", {}, (err, event) => {
            if (!err) {
                console.log('event ' + JSON.stringify(event));
                if (event.returnValues.betId == self.state.smartContractBetId) {
                    self.setState({
                        flipResponse: Number(event.returnValues.randomNumber),
                        coinIconToShow: Number(event.returnValues.randomNumber) == 1 ? <FaUserCircle className="" style={{ fontSize: "120pt" }} /> : <FaLifeRing style={{ fontSize: "120pt" }} />,
                        stillFlipping: false,
                        loadingVisible: false,
                        coinClass: "pulse",
                        flipButton: <button style={{}} onClick={self.flipCoin.bind(self)} className="custom-btn-dice">FLIP</button>,
                    });
                    self.props.AdminStore.setCoinFlipping(false);
                    setTimeout(() => {
                        if (self.state.coinClass == "pulse") {
                            self.setState({ coinClass: "" });
                        }
                    }, 6010);
                    if (self.state.coinChoice == self.state.flipResponse) {
                        self.setState({ responseText: <div style={{ color: '#27f727' }}>YOU WIN</div> });

                    } else {
                        self.setState({ responseText: <div style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</div> });
                    }
                }
            } else { console.log("error " + err) }
        });


    }

    timeoutLoop() {
        let self = this;

        setTimeout(() => {
            if (self.state.stillFlipping) {
                if (self.state.coinIconShowing == 1) {
                    self.setState({
                        coinIconShowing: 2,
                        coinIconToShow: <FaLifeRing className="" style={{ fontSize: "120pt" }} />


                    })
                } else {
                    self.setState({
                        coinIconShowing: 1,
                        coinIconToShow: <FaUserCircle className="" style={{ fontSize: "120pt" }} />

                    })
                }
                self.timeoutLoop();
            }

        }, 1450);


    }
    flipCoin() {
        let self = this;
        const { web3Store, AdminStore } = this.props;

        if (web3Store.status == "LOADED") {
            if (this.state.coinChoice === 0) {
                message.warning("YOU MUST SELECT AN OUTCOME TO BET ON");
            } else {
                this.setState({
                    responseText: "", coinClass: "flip", loadingVisible: true, stillFlipping: true, flipButton: "", coinIconToShow: <FaUserCircle className="" style={{ fontSize: "120pt" }} />
                });
                setTimeout(() => {
                    self.setState({
                        coinIconShowing: 2,
                        coinIconToShow: <FaLifeRing className="" style={{ fontSize: "120pt" }} />
                    });
                    self.timeoutLoop()
                }, 1400);

                self.props.AdminStore.setCoinFlipping(true);
                rollDice(2, this.state.coinChoice, this.state.playersBetValue).then(function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! Coin not flipped.");
                        self.setState({ stillFlipping: false, coinClass: "", loadingVisible: false, flipButton: <button style={{}} onClick={self.flipCoin.bind(self)} className="custom-btn-dice">FLIP</button> });
                        self.props.AdminStore.setCoinFlipping(false);
                    } else {
                        console.log(JSON.stringify(result));
                    }
                });




            }
        } else if (web3Store.status == "LOAD_ERROR") {
            AdminStore.actionAttemptedWithoutWeb3();
        }
    }

    betValueClicked(valueClicked) {
        if (!this.state.stillFlipping) {
            switch (valueClicked) {
                case 0.01:
                    this.setState({
                        playersBetValue: (0.01 * ethMultiplier), valueOneBorder: "solid #40a9ff 1px", valueTwoBorder: "none", valueThreeBorder: "none"
                    });
                    break;
                case 0.02:
                    this.setState({
                        playersBetValue: (0.02 * ethMultiplier), valueTwoBorder: "solid #40a9ff 1px", valueOneBorder: "none", valueThreeBorder: "none"
                    });
                    break;
                case 0.03:
                    this.setState({
                        playersBetValue: (0.03 * ethMultiplier), valueThreeBorder: "solid #40a9ff 1px", valueTwoBorder: "none", valueOneBorder: "none"
                    });
                    break;
            }
        }
    }

    coinClicked(coinChoice) {
        if (!this.state.stillFlipping) {
            this.setState({ coinChoice });
            if (coinChoice == 1) {
                this.setState({
                    smileChoiceBorder: "solid #40a9ff 2px",
                    checkChoiceBorder: "none"
                });
            } else {
                this.setState({
                    checkChoiceBorder: "solid #40a9ff 2px",
                    smileChoiceBorder: "none"
                });
            }
        }

    }
    render() {
        return (
            <div style={{ textAlign: "center" }}>
                <p style={{ fontSize: "28pt", backgroundColor: "rgba(1,1,1,0.4)", padding: "11px", borderRadius: "6px" }}>WINNING FLIP PAYS x <span style={{ color: '#27f727' }}>1.98</span></p>
                <div className={this.state.coinClass} style={{ paddingTop: "20px" }}>
                    {this.state.coinIconToShow}
                </div>
                <br />
                <br />
                <div>YOUR GUESS
                    <br />
                    <button style={{ border: this.state.smileChoiceBorder, borderRadius: "47px", padding: "3px" }} onClick={this.coinClicked.bind(this, 1)}>
                        {/* <Icon type="play-circle" style={{ fontSize: "30pt", margin: "10px" }} /> */}
                        <FaUserCircle style={{ fontSize: "35pt", margin: "10px" }} />
                    </button>
                    <button style={{ border: this.state.checkChoiceBorder, borderRadius: "47px", padding: "3px" }} onClick={this.coinClicked.bind(this, 2)}>
                        {/* <Icon type="check-circle" style={{ fontSize: "30pt", margin: "10px" }} /> */}
                        <FaLifeRing style={{ fontSize: "35pt", margin: "10px" }} />
                    </button>
                </div>
                <div>AMOUNT TO BET
                    <br />
                    <button
                        onClick={this.betValueClicked.bind(this, 0.01)}
                        style={{
                            border: this.state.valueOneBorder,
                            borderRadius: "7px",
                            padding: "5px",
                            borderWidth: "1px",
                            fontSize: "16pt"
                        }} >
                        0.01
                    </button>
                    <button
                        onClick={this.betValueClicked.bind(this, 0.02)}
                        style={{
                            border: this.state.valueTwoBorder,
                            borderRadius: "7px",
                            padding: "5px",
                            borderWidth: "1px",
                            fontSize: "16pt"
                        }}>
                        0.02
                    </button>
                    <button
                        onClick={this.betValueClicked.bind(this, 0.03)}
                        style={{
                            border: this.state.valueThreeBorder,
                            borderRadius: "7px",
                            padding: "5px",
                            borderWidth: "1px",
                            fontSize: "16pt"
                        }} >
                        0.03
                    </button>
                    <br />
                    <span style={{ fontSize: "24pt", color: "#40a9ff" }}>{(this.state.playersBetValue / ethMultiplier).toFixed(5)}</span> <FaEthereum /> ETH</div>
                <br />
                {this.state.responseText}
                {this.state.loadingVisible ? <div>GETTING FLIP FROM BLOCKCHAIN<div className="login-animation">
                    <div style={{ position: 'relative' }}><img style={{ position: 'absolute', margin: '0px 0px 0px -12px' }} src={require('../../assets/img/logoV.svg')} width="90px" /></div>
                    <ul className="loading-dots">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    <FaEthereum style={{ margin: '0 -24px 0 0', fontSize: "70pt" }} />
                </div></div>
                    : null}
                <br />
                {this.state.flipButton}
            </div>
        )
    }
}
export default CoinFlipper;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/CoinFlipper.js